import styled from 'styled-components';
import { StyledFormControlProps } from './FormControl.types';

export const StyledFormControl = styled.div<StyledFormControlProps>`
  .form-control__information-line {
    display: flex;
    justify-content: space-between;
  }

  ${(props) => props.customStyle}
`;
